"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateUserController = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var MigrateUserController = /** @class */ (function () {
    function MigrateUserController() {
        this.inFlight = false;
        this.value = '';
        this.isDirty = false;
        this.isValid = MigrateUserController.validateEmail(this.value);
        this.formError = null;
        this.hasSubmitted = false;
        this.isNewUser = null;
    }
    MigrateUserController.validateEmail = function (str) {
        return typeof str === 'string' && (0, core_shared_1.isEmailAddress)(str);
    };
    MigrateUserController.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.inFlight = true;
                        this.formError = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, services_1.Services.Rest.rest.SSOUser.selfMigrate({
                                email: this.value
                            })];
                    case 2:
                        _a.isNewUser = (_b.sent()).isNewUser;
                        this.hasSubmitted = true;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        this.formError = (0, i18n_1.Translate)(i18n_1.T.SSO_MIGRATE_FAILED);
                        return [3 /*break*/, 5];
                    case 4:
                        this.inFlight = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MigrateUserController.prototype, "hasError", {
        get: function () {
            return this.isDirty && !this.isValid;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "inFlight", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "value", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "isDirty", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "isValid", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "formError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "hasSubmitted", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], MigrateUserController.prototype, "isNewUser", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MigrateUserController.prototype, "submit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], MigrateUserController.prototype, "hasError", null);
    return MigrateUserController;
}());
exports.MigrateUserController = MigrateUserController;
//# sourceMappingURL=migrate.user.ctrl.js.map